import React, { useEffect } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { baseURL } from '../config/config';
import { post } from "../utils/apiManager";
import routes from "../routes.js";
import { LoginDetails } from "../reduxToolkit/slice/auth.js";
import AdminNavbar from "../components/Navbars/AdminNavbar.js";
import Sidebar from "../components/Sidebar/Sidebar.js";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const { token } = useSelector(state => state.auth);
  const navigate = useNavigate(); // changes page (the <Navigate> redirect component is separate)
  const dispatch = useDispatch();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  useEffect(() => {
    let tokenCheck = localStorage.getItem("token");
    if (tokenCheck && tokenCheck !== "null" && tokenCheck !== "undefined") {
      let data = { token: tokenCheck };
      const Url = `${baseURL}/admin/check-token`;
      post(Url, data).then((data) => {
        if (!data?.status || !data?.token) {
          // Expired or invalid session — sign out cleanly
          localStorage.removeItem("token");
          navigate("/auth/login");
          return;
        }
        dispatch(LoginDetails({
          token: data?.token,
          name: data?.data?.name,
          userId: data?.data?._id,
          email: data?.data?.email,
          isLogin: true,
          profileImage: data?.data?.profileImage,
        }));
      }).catch(() => navigate("/auth/login"));
    } else {
      navigate("/auth/login");
    }
  }, [token]);

  const getRoutes = (routesList) => {
    let routeElements = [];
    const extractRoutes = (items) => {
      items.forEach((prop, key) => {
        if (prop.layout === "/admin" && prop.path && prop.component) {
          routeElements.push(
            <Route path={prop.path} element={prop.component} key={`${prop.path}-${key}`} exact />
          );
        }
        if (prop.subMenu && prop.subMenu.length > 0) {
          extractRoutes(prop.subMenu);
        }
      });
    };
    extractRoutes(routesList);
    return routeElements;
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes?.length; i++) {
      if (props?.location?.pathname?.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Dashboard";
  };

  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      background: '#f5f7fb',
      fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
    }}>
      {/* Sidebar — fixed 240px */}
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/updated-logo.png"),
          imgAlt: "BidBuyZoom",
        }}
      />

      {/* Main content — offset by sidebar width */}
      <div
        ref={mainContent}
        style={{
          marginLeft: 240,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          minWidth: 0,
        }}
      >
        {/* Top bar */}
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />

        {/* Page content */}
        <div style={{ flex: 1, padding: '16px 24px 32px' }}>
          <Routes>
            {getRoutes(routes)}
            <Route path="*" element={<Navigate to="/admin/index" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Admin;
